





















































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import {
  DocumentRevision,
  IDocumentRevision,
  QuoteProductDocument
} from '@/models';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import snackbar from '@/mixins/snackbar';
import { createPdf } from '@/utils/helpers';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import DocumentDetailPDFViewerDialog from '@/components/document/DocumentDetailPDFViewerDialog.vue';

const baseMixins = mixins(Vue, snackbar);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    documentDetailPDFViewer: InstanceType<typeof DocumentDetailPDFViewerDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'DocumentRevisionHistoryDialog',

    components: { ALDialog, ErrorAlert, DocumentDetailPDFViewerDialog },

    data: () => ({
      revisionDialog: false,
      revisionLoading: false,

      document: null as QuoteProductDocument | null,

      sortBy: 'revision',
      sortDesc: true,

      revisionHeaders: [
        {
          text: 'No.',
          align: 'center',
          width: 70,
          sortable: false,
          value: 'revision'
        },

        {
          text: 'Owner',
          sortable: false,
          value: 'owner',
          width: 150
        },

        {
          text: 'Uploaded',
          align: 'start',
          sortable: false,
          value: 'uploaded_at'
        },

        {
          text: 'Current',
          align: 'center',
          sortable: false,
          value: 'latest',
          width: 50
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'actions'
        }
      ],

      errorMessage: '',
      detailErrorMessage: ''
    }),

    computed: {
      ...mapGetters({
        getDocumentRevisions: 'document/getDocumentRevisions'
      }),

      documentRevisions(): DocumentRevision[] {
        return this.getDocumentRevisions;
      }
    },

    methods: {
      moment,

      ...mapActions({
        fetchDocumentRevisions: 'document/fetchDocumentRevisions'
      }),

      downloadRevisionFile(revision: IDocumentRevision) {
        this.clearAllErrors();
        this.$services.fileLoader
          .downloadFile(revision.file)
          .then(data => {
            const fileName = `document-#${revision.revision}-${moment(
              revision.uploaded_at
            ).format('YYYY-MM-DD-HH-mm-ss')}`;
            createPdf(data, fileName);

            this.createSnack({
              color: 'success darken-1',
              type: 'success',
              right: true,
              useBtn: false,
              msg: `File attachment download successfully`,
              btnText: 'Ok',
              timeout: 6000
            });
          })
          // Not to display error
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          });
      },

      open(document: QuoteProductDocument) {
        this.revisionLoading = true;

        this.document = document;
        this.clearAllErrors();
        this.fetchDocumentRevisions(document.id)
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.revisionLoading = false;
          });
        this.revisionDialog = true;
      },

      clearAllErrors(): void {
        this.errorMessage = '';
      },

      close() {
        this.revisionDialog = false;
        this.revisionLoading = false;
      },

      openDocumentRevisionFilePreview(revision: IDocumentRevision) {
        const documentDetailPDFViewer = this.$refs.documentDetailPDFViewer;

        documentDetailPDFViewer.open(this.document!, revision);
      }
    }
  });
